export default __webpack_public_path__ + "static/get-to-know-italys-most-famous-beaches-calabria-39d53d65f94d68870d7c8cb0e22b3dd8.jpg";